/* Native disclosure navigation; cart/search continue to use the existing theme handlers. */
document.addEventListener('DOMContentLoaded', function () {
  var groups = document.querySelectorAll('.bh-nav-group');
  groups.forEach(function (group) {
    group.addEventListener('toggle', function () {
      if (group.open) groups.forEach(function (other) { if (other !== group) other.open = false; });
    });
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.bh-nav-group')) groups.forEach(function (group) { group.open = false; });
  });
  var panel = document.querySelector('.bh-mobile-panel');
  var opener = document.querySelector('.bh-header .menuleft');
  var close = panel.querySelector('.js-eveland-close');
  function closePanel() { close.click(); opener.focus(); }
  new MutationObserver(function () {
    var open = panel.classList.contains('active');
    panel.inert = !open;
    if (open) close.focus();
  }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  panel.inert = !panel.classList.contains('active');
  panel.addEventListener('click', function (event) { if (event.target.closest('a')) close.click(); });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var focused = document.activeElement.closest('details[open]');
      var expanded = focused || Array.from(groups).find(function (group) { return group.open; });
      if (expanded) { expanded.open = false; expanded.querySelector('summary').focus(); }
      else if (panel.classList.contains('active')) closePanel();
    }
    if (event.key === 'Tab' && panel.classList.contains('active')) {
      var focusable = Array.from(panel.querySelectorAll('button, summary, a[href]')).filter(function (el) { return el.getClientRects().length; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
});

